import { IBuyInfoMerchant, IBuyTransactionAmount, TProgressProps } from 'types'
// import { useApplicationCtx } from 'context/application'
import { Column, Row } from 'components/Flex'
import { tagEvent } from 'utils/tagging'
import { TTagging } from 'interface'
import ImageWithFallback from 'components/ImgFallback'

import InterWebviewBridge, { interWbSession } from '@interco/inter-webview-bridge'
import { Button } from '@interco/inter-ui/components/Button'
import { useSnackBar } from '@interco/inter-ui/components/SnackBar'

import copy_icon from '../../assets/icons/copy_icon.png'
import * as S from './styles'

type IBuyProps = {
  progress: TProgressProps | null
  merchant: IBuyInfoMerchant | null
  transactionAmount: IBuyTransactionAmount | null
  urlToNavigate: string | null
  haveRecibo: boolean
}

const BuyInfo = ({
  progress,
  merchant,
  transactionAmount,
  urlToNavigate,
  haveRecibo,
}: IBuyProps) => {
  // const { setShowBottomSheet } = useApplicationCtx()
  const { showSnackBar } = useSnackBar()

  const copy = (str: string) => {
    interWbSession.copyToClipboard('Endereço', str).then(() => {
      showSnackBar({
        title: 'Sucesso!',
        content: 'Copiado para área de transferência',
        type: 'SUCCESS',
      })
    })
  }

  const iWb = InterWebviewBridge.getInstance()

  async function handleNewWebBrowser() {
    if (!urlToNavigate) return null
    const navigateToMobile = await iWb.execute({
      action: 'navigateToNativeMPScreen',
      metadata: {
        screen: 'CARDS_BROWSER_ACCESS',
        parameters: {
          url: urlToNavigate,
        },
      },
    })
    return navigateToMobile
  }

  return (
    <Column $alignItems="start" $paddingTop="1rem" $gap="none">
      <Row>
        <S.SpanEtapas>
          Passo {progress?.num}/{progress?.totalSteps}
        </S.SpanEtapas>
      </Row>
      <Column $alignItems="center" $gap="none">
        {merchant?.logos?.[1] && (
          <Row $justifyContent="center">
            <ImageWithFallback
              src={merchant?.logos[0].url}
              alt={merchant?.logos[0].altTextTag ?? ''}
              style={{
                height: '64px',
                width: '64px',
              }}
            />
          </Row>
        )}
        <Row $justifyContent="center">
          <S.SpanValor>{transactionAmount?.value}</S.SpanValor>
        </Row>
        <Row $justifyContent="center">
          <S.SpanNomeLoja>{merchant?.name}</S.SpanNomeLoja>
        </Row>
        <Row $justifyContent="center">
          {haveRecibo ? (
            <Button
              variant="link"
              onClick={() => {
                // setShowBottomSheet(true)
                handleNewWebBrowser()
                tagEvent({
                  type: 'ETHOCA_FLUXO_ACESSO',
                  screen: 'card-webview-ethoca-contestation',
                  content_action: 'Toque',
                  product: 'contestacao_ethoca',
                  action_id: 'Mostrar recibo',
                } as TTagging)
              }}
            >
              Mostrar recibo
            </Button>
          ) : (
            <br />
          )}
        </Row>
      </Column>
      {merchant?.address && Object.keys(merchant?.address).length > 0 && (
        <>
          <Row $marginBottom="8px">
            <S.SpanLocation>Localização da loja</S.SpanLocation>
          </Row>
          <Row $marginBottom="8px" $justifyContent="space-between">
            <S.SpanEndereco>
              {merchant?.address?.line1}, {merchant?.address?.city}
            </S.SpanEndereco>
            <Button
              variant="link"
              onClick={() => {
                copy(`${merchant?.address?.line1}, ${merchant?.address?.city}`)
                tagEvent({
                  type: 'ETHOCA_FLUXO_ACESSO',
                  screen: 'card-webview-ethoca-contestation',
                  content_action: 'Toque',
                  product: 'contestacao_ethoca',
                  action_id: 'copiar',
                } as TTagging)
              }}
              style={{ padding: '0px' }}
            >
              <img src={copy_icon} alt="copiar endereço" />
            </Button>
          </Row>
        </>
      )}
    </Column>
  )
}

export default BuyInfo
